import { render, staticRenderFns } from "./FaultsCollapsableTableWithHeaderFilters.vue?vue&type=template&id=52956546"
import script from "./FaultsCollapsableTableWithHeaderFilters.vue?vue&type=script&lang=js"
export * from "./FaultsCollapsableTableWithHeaderFilters.vue?vue&type=script&lang=js"
import style0 from "./FaultsCollapsableTableWithHeaderFilters.vue?vue&type=style&index=0&id=52956546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports